import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const AllSessionApi = createApi({
  reducerPath: "allSessionApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["session"],
  endpoints: (builder) => ({
    getAllEventSession: builder.query({
      query: (eventId) => ({
        url: `/session/all/${eventId}`,
        method: "GET"
      }),
      providesTags: ["session"]
    }),
    postCreateSessionApi: builder.mutation({
      query: (data) => ({
        url: "/session",
        method: "POST",

        body: data
      }),
      invalidatesTags: ["session"]
    }),
    deleteSession: builder.mutation({
      query: (session) => ({
        url: `/session/${session.id}`,
        method: "DELETE"
      }),
      invalidatesTags: ["session"]
    }),
    cloneSession: builder.query({
      query: (sessionId) => ({
        url: `/session/clone/${sessionId}`,
        method: "GET"
      }),
      providesTags: ["session"]
    }),
    updateStatusOfSession: builder.mutation({
      query: ({ data, id }: { data: any; id: any }) => ({
        url: `/session/cancel/${id}`,
        method: "POST",
        body: data
      })
    })
  })
});

export const {
  useGetAllEventSessionQuery,
  usePostCreateSessionApiMutation,
  useDeleteSessionMutation,
  useLazyCloneSessionQuery,
  useUpdateStatusOfSessionMutation
} = AllSessionApi;
